<template>
  <div v-if="posts && posts.length">
    <v-container class="pt-3">
      <h4
        class="title grey--text text--darken-1 pt-0 pb-0"
        v-html="$store.getters.getLangKey('latestPosts')" />
    </v-container>
    <v-list dense>
      <v-list-tile
        ripple
        router
        v-for="(post, index) in posts"
        :key="index"
        :title="post.title"
        :to="createPostUrl(post.date, post.slug)">
        <v-list-tile-content>
          <v-list-tile-title v-html="post.title" />
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon>chevron_right</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>
<script>
  import Mixins from '../helpers/Mixins'

  export default {
    name: 'LatestPostsSidebar',
    mixins: [
      Mixins
    ],
    data () {
      return {
        posts: this.$store.state.bootstrapData.recentPosts || []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LatestPostsSidebar.vue